<template>
  <!-- Products -->
  <div class="title-bar" style="margin-bottom: 0px"><h2 class="dz-title">Os mais procurados</h2></div>
  <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false"
       class="swiper swiper-init main-swiper mb-40 overlay-swiper1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="prod in prodProList" :key="prod.id">
        <div class="card-overlay style-1 bg-primary"
             style="height: 16.5em; display: flex; flex-wrap: wrap; align-content: center;"
             @click="addToCart(`${ prod.id }`, $event)">
          <div class="dz-media">
            <div class="img-container">
              <img
                :src="getProductImage(prod)"
                class="product-img"
                alt=""
                @load="onImgLoad"
              />
            </div>
          </div>
          <div class="dz-info">
            <h5 class="item-title title"><a href="/item-details/">{{ prod.title }}</a></h5>
            <div class="dz-meta" style="width: 180px">
              <ul style="justify-content: space-between">
                <li class="price">{{ prod.price }}<sup>€</sup></li>
                <li class="mt-5"><img style="width: 24px; height: 24px" :src="`${ allergen }`" v-for="allergen in prod.alergenio_image"
                           :key="allergen.id"/></li>
              </ul>
            </div>
            <div class="dz-meta">

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Categories -->
  <div class="title-bar">
    <h4 class="dz-title">Categorias</h4>
  </div>
  <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false"
       class="swiper swiper-init mb-40 main-swiper categories-swiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="item in categoriesList" :key="item.id">
        <a @click="toggleCategoryId(`${ item.id }`)">
          <div class="categories-bx" style="align-items: center;">
            <!--
            <div class="icon-bx">
              <a href="/">
                <img :src="`${ item.image }`" alt="" style="fill: #debdbd;">
              </a>
            </div>
          -->
            <div class="dz-content">
              <h5 class="title"><a href="/" @click="toggleCategoryId(`${ item.id }`)">{{
                  item.title
                }}</a></h5>
              <span class="menus text-primary">{{ getTotalText(item.total) }}</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>

  <!-- Promoções -->
  <PromoBar v-if="promoList.length > 0" :promoList="promoList"></PromoBar>
</template>

<script>
import axios from "axios";
import Swiper from "swiper";
import PromoBar from "@/components/PromoBar";


export default {
  name: 'MainPage',
  components: {PromoBar},
  props: ['prodProList', 'categoriesList', 'categoryId', 'promoList'],
  emits: ['toggle-category-products'],

  async mounted() {
    this.clearCache()
    new Swiper('.swiper-init', {
      // Swiper configuration options
      spaceBetween: 20,
      slidesPerView: 'auto',
      centeredSlides: false,
      observer: true,
      observeParents: true,
    });
  },

  methods: {
    clearCache() {
      setTimeout(() => {
        localStorage.clear();
      }, 100);
    },

    //300000

    addToCart(id, event) {
      // Adiciona efeito visual de clique
      const card = event.currentTarget;
      card.classList.add('clicked');
      
      // Remove a classe após a animação
      setTimeout(() => {
        card.classList.remove('clicked');
      }, 300);
      
      this.$store.commit('addToCard', this.prodProList.find(i => i.id === id))
    },
    getTotalText(total) {
      return total > 1 ? `${total} produtos` : `${total} produto`;
    },
    async toggleCategoryId(id) {
      let categoryProductList = {};
      try {
        const category = await this.loadCategory(id);
        const products = await this.loadProducts(id);
        categoryProductList['category'] = category;
        categoryProductList['products'] = products;
        this.$emit('toggle-category-products', categoryProductList);
      } catch (error) {
        console.error(error.message);
      }
    },

    async loadProducts(id) {
      const regex = /[a-zA-Z0-9]/g;
      let productUrl = process.env.VUE_APP_SERVICE_URL + 'products?category=' + id;
      let productUrlRegex = productUrl.match(regex).join('');
      let cachedProductUrl = localStorage.getItem(productUrlRegex);
      if (cachedProductUrl) {
        return JSON.parse(cachedProductUrl);
      } else {
        try {
          const response = await axios.get(productUrl);
          localStorage.setItem(productUrlRegex, JSON.stringify(response.data.products));
          return response.data.products; // Fixed the return statement
        } catch (error) {
          console.error(error.message);
          throw error;
        }
      }
    },

    async loadCategory(id) {
      const regex = /[a-zA-Z0-9]/g;
      let categoryUrl = process.env.VUE_APP_SERVICE_URL + 'category?category=' + id;
      let categoryUrlRegex = categoryUrl.match(regex).join('');
      let cachedCategoryUrl = localStorage.getItem(categoryUrlRegex);
      if (cachedCategoryUrl) {
        return JSON.parse(cachedCategoryUrl);
      } else {
        try {
          const response = await axios.get(categoryUrl, {params: {category: id}});
          localStorage.setItem(categoryUrlRegex, JSON.stringify(response.data[0]));
          return response.data[0];
        } catch (error) {
          console.error(error.message);
          throw error;
        }
      }
    },
    getProductImage(item){
      if(item.category === "Baguetes"){
        if(item.id === "80"){
          return '/assets/img/products/baguetes/baguette branca com fiambre.png'
        }
        if(item.id === "81"){
          return "/assets/img/products/baguetes/baguette branca com queijo.png"
        }
        if(item.id === "82"){
          return "/assets/img/products/baguetes/baguette branca mista.png"
        }
        if(item.id === "83"){
          return "/assets/img/products/baguetes/baguette branca com pasta de atum.png"
        }
        if(item.id === "84"){
          return "/assets/img/products/baguetes/baguette multicereais com pasta de delicias do mar.png"
        }
        if(item.id === "85"){
          return "/assets/img/products/baguetes/baguette multicereais com fiambre.png"
        }
        if(item.id === "86"){
          return "/assets/img/products/baguetes/baguette multicereais com queijo.png"
        }
        if(item.id === "87"){
          return "/assets/img/products/baguetes/baguette multicereais mista.png"
        }
        if(item.id === "88"){
          return "/assets/img/products/baguetes/baguette multicereais com pasta de atum.png"
        }
        if(item.id === "89"){
          return "/assets/img/products/baguetes/baguette branca com pasta de delicias do mar.png"
        }
        if(item.id === "90"){
          return "/assets/img/products/baguetes/baguette sem gluten com queijo.png"
        }
        if(item.id === "91"){
          return "/assets/img/products/baguetes/baguette sem gluten com fiambre.png"
        }
        if(item.id === "92"){
          return "/assets/img/products/baguetes/baguette sem gluten mista.png"
        }
        if(item.id === "93"){
          return "/assets/img/products/baguetes/baguette sem gluten com pasta de atum.png"
        }
        if(item.id === "96"){
          return "/assets/img/products/baguetes/baguette sem gluten com pasta de delicias do mar.png"
        }
      }
      if(item.category === "Tostas"){
        if(item.id === "32"){
          return '/assets/img/products/tostas/tosta de fiambre.png'
        }
        if(item.id === "33"){
          return '/assets/img/products/tostas/tosta de queijo.png'
        }
        if(item.id === "34"){
          return '/assets/img/products/tostas/tosta mista.png'
        }
        if(item.id === "35"){
          return '/assets/img/products/tostas/tosta de pasta de atum.png'
        }
        if(item.id === "36"){
          return '/assets/img/products/tostas/tosta de pasta de delicias do mar.png'
        }
      }
      if(item.category === "Torradas"){
        if(item.id === "30"){
          return '/assets/img/products/torradas/torrada com compota de abobora.png'
        }
        if(item.id === "31"){
          return '/assets/img/products/torradas/torrada com manteiga.png'
        }
        if(item.id === "130"){
          return '/assets/img/products/torradas/torrada com compota de frutos vermelhos.png'
        }
        if(item.id === "134"){
          return '/assets/img/products/torradas/torrada com creme de barrar de bolachas belgas Lotus Biscoff.png'
        }
      }
      if(item.category === "Bolos"){
        if(item.id === "42"){
          return '/assets/img/products/bolos/nata.png'
        }
        if(item.id === "111"){
          return '/assets/img/products/bolos/tarte_maçã.png'
        }
      }
      if(item.category === "Bebidas Quentes"){
        if(item.id === '1' || item.id === '3' ||item.id === '4'|| item.id === '107' || item.id === '109'){
          return '/assets/img/products/bebidas quentes/Café.png'
        }
        if(item.id === '5'){
          return '/assets/img/products/bebidas quentes/chinesa.png'
        }
        if(item.id === '2'){
          return '/assets/img/products/bebidas quentes/galão.png'
        }
        if(item.id === '7' || (item.id >= '54' && item.id <= '59')){
          return '/assets/img/products/bebidas quentes/Chá.png'
        }
        if(item.id === '60'){
          return '/assets/img/products/bebidas quentes/chocolate quente.png'
        }
      }
      if(item.category === "Bebidas Frias"){
          if(item.id === '9'){
            return '/assets/img/products/bebidas frias/atlantida_semgas_22_final.jpg'
          }
          if(item.id === '10'){
            return '/assets/img/products/bebidas frias/Coral_PuroMalte 2019.jpg'
          }
          if(item.id === '11'){
            return '/assets/img/products/bebidas frias/Coral_STOUT 20cl_2022.jpg'
          }
          if(item.id === '15'){
            return '/assets/img/products/bebidas frias/ucal.png'
          }
          if(item.id === '16'){
            return '/assets/img/products/bebidas frias/brisa-maca-0_36Lt-800x800-1.jpg'
          }
          if(item.id === '17'){
            return '/assets/img/products/bebidas frias/Brisa Maracuja_36CL 2017.jpg'
          }
          if(item.id === '19'){
            return '/assets/img/products/bebidas frias/compal manga cenoura laranja.png'
          }
          if(item.id === '20'){
            return '/assets/img/products/bebidas frias/compal pessego.png'
          }
          if(item.id === '21'){
            return '/assets/img/products/bebidas frias/compal laranja.png'
          }
          if(item.id === '23'){
            return '/assets/img/products/bebidas frias/compal maracuja.png'
          }
          if(item.id === '45'){
            return '/assets/img/products/bebidas frias/cerveja pressão.png'
          }
          if(item.id === '48'){
            return '/assets/img/products/bebidas frias/Laranjada 33cl.jpg'
          }
          if(item.id === '49'){
            return '/assets/img/products/bebidas frias/Brisa-Maracuja-sem-acucar-036.jpg'
          }
          if(item.id === '50'){
            return '/assets/img/products/bebidas frias/compal pera.png'
          }
          if(item.id === '51'){
            return '/assets/img/products/bebidas frias/c.-frutos-vermelhos-0.2l.png'
          }
          if(item.id === '52'){
            return '/assets/img/products/bebidas frias/Atlantida 50 cl_blue .jpg'
          }
          if(item.id === '53'){
            return '/assets/img/products/bebidas frias/atlantida_gas_22_final.jpg'
          }
          if(item.id === '61'){
            return '/assets/img/products/bebidas frias/fuze-tea-limao-vidro-300ml-produto.jpg'
          }
          if(item.id === '62'){
            return '/assets/img/products/bebidas frias/fuze-tea-pessego-vidro-300ml-produto.jpg'
          }
          if(item.id === '63'){
            return '/assets/img/products/bebidas frias/fuze-tea-manga-ananas-vidro-300ml-produto.jpg'
          }
          if(item.id === '65'){
            return '/assets/img/products/bebidas frias/coca-cola-original-vidro-350ml-gotas.png'
          }
          if(item.id === '68'){
            return '/assets/img/products/bebidas frias/coca-cola-zero-acucar-vidro-350ml-gotas.png'
          }
          if(item.id === '69'){
            return '/assets/img/products/bebidas frias/fanta-laranja-vidro-350ml.png'
          }
          if(item.id === '70'){
            return '/assets/img/products/bebidas frias/fanta-ananas-vidro-350ml-gotas.png'
          }
          if(item.id === '97'){
            return '/assets/img/products/bebidas frias/monster.jpg'
          }
          if(item.id === '99'){
            return '/assets/img/products/bebidas frias/bandida maça.png'
          }
          if(item.id === '100'){
            return '/assets/img/products/bebidas frias/água com limão - castello.png'
          }
          if(item.id === '101'){
            return '/assets/img/products/bebidas frias/sprite-vidro-350ml-gotas.png'
          }
          if(item.id === '102'){
            return '/assets/img/products/bebidas frias/coca-cola-zero-baunilha-lata-sleek-330ml-gotas.png'
          }
          if(item.id === '103'){
            return '/assets/img/products/bebidas frias/monster_energy_ultra-350x350.png'
          }
          if(item.id === '106'){
            return 
          }
      }
      if(item.category === "Gelados"){
        if(item.id === '112'){
          return '/assets/img/products/gelados/calipo limão.png'
        }
        if(item.id === '113'){
          return '/assets/img/products/gelados/perna de pau.png'
        }
        if(item.id === '114'){
          return '/assets/img/products/gelados/solero exotic.jpg'
        }
        if(item.id === '115'){
          return '/assets/img/products/gelados/cornetto filipino.png'
        }
        if(item.id === '116'){
          return '/assets/img/products/gelados/CORNETTO-CLASSIC-VANILLA-600x600.png'
        }
        if(item.id === '117'){
          return '/assets/img/products/gelados/cornetto morango.png'
        }
        if(item.id === '118'){
          return '/assets/img/products/gelados/filipinos sandwich.png'
        }
        if(item.id === '119'){
          return '/assets/img/products/gelados/magnum sandwich.jpg'
        }
        if(item.id === '120'){
          return '/assets/img/products/gelados/Magnum Double Gold billionaire.jpg'
        }
        if(item.id === '121'){
          return '/assets/img/products/gelados/Magnum chocolate branco.png'
        }
        if(item.id === '122'){
          return '/assets/img/products/gelados/Magnum de amêndoas.png'
        }
        if(item.id === '124'){
          return '/assets/img/products/gelados/Calippo de morango.jpg'
        }
      }
      if(item.category === "Pizzas"){
        if(item.id === "131"){
          return '/assets/img/products/pizzas/pizza romana.jpg'
        }
        if(item.id === "132"){
          return '/assets/img/products/pizzas/pizza pepperoni.jpg'
        }
        if(item.id === "133"){
          return '/assets/img/products/pizzas/pizza margerita.png'
        }
      }
      if(item.category === "Nuggets"){
        if(item.id === "138"){
          return "/assets/img/products/nuggets/10NuggetsFrango.png";
        }
        if(item.id === "139"){
          return "/assets/img/products/nuggets/5NuggetsFrango.png";
        }
      }
      return item.image;
    },
    onImgLoad(event) {
      const img = event.target;
      const container = img.parentElement;
      const cW = container.clientWidth;
      const cH = container.clientHeight;
      // se a imagem é menor ou igual ao contêiner, mantém tamanho natural (sem upscale)
      if (img.naturalWidth <= cW && img.naturalHeight <= cH) {
        img.style.width = 'auto';
        img.style.height = 'auto';
      } else {
        // se for maior, faz fit no contêiner mantendo proporção
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
      }
    },
  },
};
</script>

<style>
.bg-primary {
  background-color: #ffffff !important; 
  border: 1px solid #efefef !important;
  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.1) !important;
  color: #000 !important;
  transition: all 0.3s ease !important;
  cursor: pointer !important;
}

.bg-primary:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  border-color: #04764e !important;
}

.bg-primary:active {
  transform: translateY(0) scale(0.98) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.1s ease !important;
}

/* Animação de pulse quando clicado */
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}

.bg-primary.clicked {
  animation: pulse 0.3s ease;
}
.bg-primary * {
  color: #000 !important; 
}

.card-overlay { overflow: hidden; } /* evita que a imagem "vaze" pelas bordas arredondadas */

.dz-media {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

/* Contêiner fixo para as imagens dos produtos */
.img-container {
  width: 140px;    /* ajusta conforme queres */
  height: 140px;   /* ajusta conforme queres */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0 auto;
  background: transparent;
}

/* regra base: não força upscale; object-fit aplicado dinamicamente no load */
.product-img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.bg-primary:hover .product-img {
  transform: scale(1.05);
}

/* responsivo */
@media (max-width: 600px) {
  .img-container { width: 110px; height: 110px; }
}
</style>

